var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"CampaignShowModal",attrs:{"size":"md"},on:{"close":_vm.close}},[_c('div',{staticClass:"-m-t-xl -m-b-md"},[_c('campaign-show-full',{attrs:{"campaign":_vm.campaign,"user":_vm.user}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }